export class cRelatedProductsPackagingUnit {
  selectInput;

  constructor(id: string) {
    const query = `.c-related-products[data-item-id='${id}'] `;
    this.selectInput   = document.querySelector(query + '.c-related-products-packaging-unit select') as HTMLInputElement;

    if (this.selectInput === null) return;
    this.selectInput.addEventListener('change', () => {
      window.location.href  = this.selectInput.value;
    });
  }
}